<script lang="ts" setup>
import { computed, defineEmits, defineProps } from "vue";
import { useI18n } from "vue-i18n";
import { AddonType } from "@/struct/AddonsStruct";
import { PropType } from "@vue/runtime-core";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";

const props = defineProps({
  chosenAddon: {
    type: Object as PropType<AddonType>,
    required: true,
  },
  isActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["action", "close"]);
const { t } = useI18n();

const emitAction = (addon: AddonType) => {
  emit("action", addon);
};

const returnBtnTitle = computed(() =>
  props.isActive ? t("common.actions.disable") : t("common.actions.connect")
);
</script>

<template>
  <div class="addons-details">
    <div class="addons-details__title">
      <p class="h1">{{ chosenAddon.name }}</p>
    </div>
    <div class="addons-details__subtitle">
      <p v-if="chosenAddon.activation_price === '0.00'" class="caption-medium">
        {{ t("common.labels.free") }}
      </p>
      <p v-else class="caption-medium">
        {{ Math.floor(parseInt(chosenAddon.activation_price)) }}₽
        {{ t("common.labels.perMonth") }}
      </p>
    </div>
    <div class="addons-details__buttons">
      <a href="/docs/offerte_msc.pdf" target="_blank">
        <button class="addons-details__buttons-item">
          <p class="button-small">{{ t("common.labels.offer") }}</p>
          <BaseIcon
            name="download"
            class="addons-details__buttons-item__icon"
          />
        </button>
      </a>
    </div>
    <div class="addons-details__actions">
      <BaseButton
        :title="returnBtnTitle"
        :color="isActive ? 'grey' : 'primary'"
        @click="emitAction(chosenAddon)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/components/addons";
</style>
